import React, { useEffect, useState, useCallback } from "react";
import { PendingNavbar } from "./reusedcomponent/Navbar";
import moment from "moment";
import RejectModal from "./model/rejectLeave";
import { capitalize } from "../../../utils/capitalize";
import { ApiService } from "../../../services/ApiService";
import useModal from "../../../utils/useModal";
import Modal from "react-modal";
import { ConfirmTemplate } from "../../../components/confirm";
import Checkbox from "./reusedcomponent/checkBox";
import { useAlert } from "react-alert";
import EditLeaveRequestModal from "./model/edit_leave_request";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

export const pendingLeaveRequests = () => {
  const alert = useAlert();

  const [pendingLeaves, setPendingLeaves] = useState({
    data: [],
    requestType: [],
    next: null,
    prev: "",
    currentPage: 1,
    last: "",
  });
  const [checkedItems, setCheckedItems] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);

  const { modalIsOpen, openModal, closeModal } = useModal();
  const [EditValue, setEditValue] = useState([]);
  const [open, setOpen] = useState(false);

  const [Loading, setLoading] = useState(false);
  const load = <span className="fa fa-spin fa-spinner"></span>;

  const openEditModal = () => {
    setOpen(true);
  };

  const closeEditModal = () => {
    setOpen(false);
  };

  const approveManyRequest = (ids) => {
    const request = async () => {
      setLoading(true)
      const request_id = {
        request_id: ids,
      };
      const res = await ApiService.post(
        `leave-requests/approve-leave-request/${0}`,
        request_id
      );
      if (res.data.type === false || res.data.errors) {
        if (res.data.errors) {
          let meesg = res.data.errors[0];
          alert.error(meesg);
        }
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getPendingLeaves();
      }
      getPendingLeaves();
      setCheckedItems([]);
      setCheckedAll(false);
      setLoading(false)
    };
    ConfirmTemplate(
      {
        title: "Approve Requests",
        message: "Are You Sure ?",
      },
      request
    );
  };

  const rejectRequest = async (ids, reason) => {
    setLoading(true)
    const request_id = {
      request_id: ids,
      reason_for_rejection: reason,
    };
    const res = await ApiService.post(
      `leave-requests/reject-leave-request/${0}`,
      request_id
    );
    if (res.data.type === false || res.data.errors) {
      if (res.data.errors) {
        let meesg = res.data.errors[0];
        alert.error(meesg);
      }
      alert.error(res.data.msg);
    } else if (res.data.type === true) {
      alert.success(res.data.msg);
    }
    getPendingLeaves();
    setCheckedItems([]);
    setCheckedAll(false);
    setLoading(false)
  };

  const confirmRejection = () => {
    const request = () => {
      openModal();
    };
    ConfirmTemplate(
      {
        title: "Reject Requests",
        message: "Are You Sure ?",
      },
      request
    );
  };

  const getPendingLeaves = async (query = "?page=1") => {
    setLoading(true);
    const response = await ApiService.get(`leave-requests/pending${query}`);
    const Requests = !Array.isArray(
      response.data && response.data.leave_requests.data
    )
      ? Object.values(response.data && response.data.leave_requests.data)
      : response.data.leave_requests.data;

    const leaveRequest = Requests.map((d) => {
      return { ...d, isChecked: false };
    });

    const { last_page_url, prev_page_url, next_page_url, current_page } =
      response.data.leave_requests;

    setPendingLeaves({
      data: leaveRequest,
      requestType: response.data.requestType,
      last: last_page_url,
      prev: prev_page_url,
      currentPage: current_page,
      next: next_page_url,
    });
    setLoading(false);
  };

  const handleAllChecked = (event) => {
    let leavess = pendingLeaves.data;
    let checkIds = new Set(checkedItems);
    leavess.forEach((l) => (l.isChecked = event.target.checked));
    leavess.forEach((l) => {
      if (l.isChecked) {
        checkIds.add(l.id);
      } else {
        checkIds = new Set();
      }
    });
    setCheckedItems([...checkIds]);
    setPendingLeaves({ data: leavess });
    setCheckedAll(!checkedAll);
  };

  const handleCheckChieldElement = (event) => {
    let leaves = pendingLeaves.data;
    let checkIds = [...new Set(checkedItems)];
    leaves.forEach((l) => {
      if (l.id === Number(event.target.value))
        l.isChecked = event.target.checked;
    });

    leaves.forEach((l) => {
      if (l.isChecked) {
        checkIds.push(l.id);
      }
      if (l.isChecked == false && checkIds.indexOf(l.id) !== -1) {
        checkIds.splice(checkIds.indexOf(l.id), 1);
      }
    });

    setCheckedItems([...new Set(checkIds)]);
    setPendingLeaves({ data: leaves });
    setCheckedAll(false);
  };

  const handleApprove = () => {
    approveManyRequest(checkedItems);
  };

  const handlereject = () => {
    confirmRejection();
  };

  useEffect(() => {
    getPendingLeaves();
  }, []);

  let activePage = pendingLeaves.currentPage;

  return (
    // <PageBody isLoading={isLoading} message={message}>
    <React.Fragment>
      <PendingNavbar />

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="create-on-leave request modal"
      >
        <RejectModal
          rejectRequest={rejectRequest}
          closeModal={closeModal}
          alert={alert}
          getRequest={getPendingLeaves}
          request={checkedItems}
        />
      </Modal>

      <Modal
        isOpen={open}
        onRequestClose={closeEditModal}
        style={customStyles}
        contentLabel="edit-on-leave request modal"
      >
        <EditLeaveRequestModal
          alert={alert}
          pendingLeaves={pendingLeaves}
          getRequest={getPendingLeaves}
          value={EditValue}
          closeModal={closeEditModal}
          approveRequest={approveManyRequest}
        />
      </Modal>

      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <div className="card-title">
                    <div className="table-title">
                      <div className="row container-fluid">
                        <div className="col-sm-5">
                          <h2>
                            <b>PENDING LEAVE REQUEST</b>
                          </h2>
                        </div>
                        <div className="col-sm-6"></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8"></div>
                    <div className="form-group col-md-2">
                      <form class="form-inline my-2 my-lg-0 float-right">
                        <div
                          class="btn-group p-2"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary"
                            onClick={handleApprove}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            {Loading ? load : " Approve selected"}
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger"
                            onClick={handlereject}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            {Loading ? load : "Reject Selected"}
                          </button>
                        </div>
                        {/* <div
                          class="btn-group p-2"
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary"
                            onClick={handleApprove}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            Approve selected
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger"
                            onClick={handlereject}
                            disabled={checkedItems.length < 1 ? true : false}
                          >
                            Reject Selected
                          </button>
                        </div> */}
                      </form>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered office-request-table">
                      {pendingLeaves.data.length > 0 ? (
                        <thead>
                          <tr>
                            <th>S/N</th>
                            <th>Leave Type </th>
                            <th>Employee Name</th>
                            <th>Date Requested</th>
                            <th>Start Date</th>
                            <th>End Date</th>
                            <th>Leave Days</th>

                            <th>
                              Select
                              {Loading ? load : (
                                <div>
                                  <input
                                    type="checkbox"
                                    onClick={handleAllChecked}
                                    value="checkedall"
                                    checked={checkedAll}
                                  />{" "}
                                  Check / Uncheck All
                                </div>
                              )}
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                      ) : (
                        <div className="text-center m-auto">
                          <h1 className="text-dark">
                            No pending leave requests
                          </h1>
                        </div>
                      )}
                      <tbody>
                        {pendingLeaves.data.map((request, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{request.leave_id.type}</td>
                            <td>
                              {capitalize(request.requested_by.first_name) +
                                " " +
                                capitalize(request.requested_by.last_name)}
                            </td>
                            <td>
                              {moment(request.requested_on).format("MMM Do YY")}
                            </td>
                            <td>
                              {moment(request.start_date).format("MMM Do YY")}
                            </td>
                            <td>
                              {moment(request.end_date).format("MMM Do YY")}
                            </td>
                            <td>{request.leave_days} </td>
                            <td>
                              <Checkbox
                                handleCheckChieldElement={
                                  handleCheckChieldElement
                                }
                                {...request}
                              />
                            </td>
                            <td>
                              <a
                                className="dropdown-item"
                                onClick={() => {
                                  const value = {
                                    id: request.id,
                                    request_type: request.leave_id.id,
                                    start_date: request.start_date,
                                    end_date: request.end_date,
                                  };
                                  setEditValue(value);
                                  openEditModal();
                                }}
                                id="edit_leave_request_btn"
                              >
                                <i
                                  style={{ cursor: "pointer" }}
                                  className="material-icons"
                                  data-toggle="tooltip"
                                  title="Edit"
                                >
                                  &#xE254;
                                </i>{" "}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <nav aria-label="...">
                      <ul class="pagination">
                        <li
                          class={`page-item ${pendingLeaves.prev === null ? "disabled" : ""
                            }`}
                        >
                          <a
                            class="page-link"
                            onClick={() => getPendingLeaves(pendingLeaves.prev)}
                            aria-disabled={
                              !pendingLeaves.data.prev_page_url
                                ? "true"
                                : "false"
                            }
                          // aria-disabled={activityLog.prev_page_url}
                          >
                            Previous
                          </a>
                        </li>
                        {[...Array(pendingLeaves.last).keys()].map(
                          (page, i) => (
                            <li
                              class={`page-item ${page + 1 === activePage ? "active" : ""
                                }`}
                              key={i}
                            >
                              <a
                                class="page-link"
                                id={page + 1}
                                onClick={() =>
                                  getPendingLeaves(`?page=${page + 1}`)
                                }
                              >
                                {page + 1}
                              </a>
                            </li>
                          )
                        )}
                        <li
                          class={`page-item ${pendingLeaves.next === null ? "disabled" : ""
                            }`}
                        >
                          <a
                            class="page-link"
                            onClick={() => getPendingLeaves(pendingLeaves.next)}
                          >
                            {Loading ? load : "Next"}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    // </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/pending/leave_request.js